var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      title: _vm.$t("字段配置"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 800,
      footer: null
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_vm.isAuth("home.permissionsFieldStore") ? _c("a-button", {
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("添加")))]) : _vm._e(), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      columns: _vm.columns,
      "data-source": _vm.data,
      bordered: "",
      pagination: false,
      scroll: {
        y: 300
      },
      rowKey: (record, index) => {
        return index;
      }
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "id",
      fn: function (text, record, index) {
        return [_vm._v(_vm._s(index + 1))];
      }
    }, _vm._l(["field", "name", "sort", "config"], function (col) {
      return {
        key: col,
        fn: function (text, record) {
          return [_c("div", {
            key: col,
            style: !record.editable && col == "config" ? "width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" : ""
          }, [record.editable && col != "sort" ? _c("a-input", {
            staticStyle: {
              margin: "-5px 0"
            },
            attrs: {
              value: text
            },
            on: {
              change: e => _vm.handleChange(e.target.value, record.key, col)
            }
          }) : _vm._e(), record.editable && col == "sort" ? _c("a-input", {
            staticStyle: {
              margin: "-5px 0"
            },
            attrs: {
              value: text
            },
            on: {
              change: e => _vm.handleChange(e.target.value, record.key, col)
            }
          }) : col != "config" && !record.editable ? [_vm._v(" " + _vm._s(_vm.$t(text)) + " ")] : !record.editable ? _c("a-tooltip", {
            attrs: {
              placement: "topLeft"
            }
          }, [_c("template", {
            slot: "title"
          }, [_vm._v(" " + _vm._s(_vm.$t(text)) + " ")]), _vm._v(" " + _vm._s(_vm.$t(text)) + " ")], 2) : _vm._e()], 2)];
        }
      };
    }), {
      key: "operation",
      fn: function (text, record, index) {
        return [_vm.isAuth("home.permissionsFieldEdit") ? _c("div", {
          staticClass: "editable-row-operations"
        }, [record.editable ? _c("span", [_c("a", {
          on: {
            click: () => _vm.save(record.key)
          }
        }, [_vm._v(_vm._s(_vm.$t("保存")))]), _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("确认关闭") + "?"
          },
          on: {
            confirm: () => _vm.cancel(record.key)
          }
        }, [_c("a", [_vm._v(_vm._s(_vm.$t("关闭")))])])], 1) : _c("span", [_c("a", {
          attrs: {
            disabled: _vm.editingKey !== ""
          },
          on: {
            click: () => _vm.edit(record.key)
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]), _vm.isAuth("home.permissionsFieldDelete") ? _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("确认删除") + "?"
          },
          on: {
            confirm: () => _vm.del(index)
          }
        }, [_c("a", [_vm._v(_vm._s(_vm.$t("删除")))])]) : _vm._e()], 1)]) : _vm._e()];
      }
    }], null, true)
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };